<template>
  <div class="page-helper">
    <a-card title="发布助手">
      <a-icon slot="extra" type="down"/>
      <p>Hi，我是发布助手～可以实时检测内容提出优化建议，帮你提升商品内容质量。</p>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'PublishHelper',
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style lang="less" scoped>
.page-helper {
  max-width: 256px;
  height: 265px;
  flex-shrink: 0;
}
</style>